var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoDont(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 362,
    height: 202,
    viewBox: "0 0 362 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 362,
    height: 202,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 43,
    width: 130,
    height: 78,
    fill: "#ECEEEE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 43,
    width: 130,
    height: 78,
    fill: "#ECEEEE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 124,
    width: 130,
    height: 4,
    fill: "#E7F6E4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 124,
    width: 130,
    height: 4,
    fill: "#F9E8E8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 131,
    width: 15,
    height: 7,
    fill: "#39B620"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 131,
    width: 15,
    height: 7,
    fill: "#CA3C3D"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 60,
    width: 33,
    height: 44,
    fill: "#E2E5E5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 60,
    width: 33,
    height: 44,
    fill: "#E2E5E5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 141,
    width: 130,
    height: 4,
    fill: "#E2E5E5"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 172,
    width: 277,
    height: 5,
    fill: "#E2E5E5"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 3,
    width: 277,
    height: 5,
    fill: "#E2E5E5"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 182,
    width: 277,
    height: 5,
    fill: "#E2E5E5"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 13,
    width: 277,
    height: 5,
    fill: "#E2E5E5"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 192,
    width: 91,
    height: 5,
    fill: "#E2E5E5"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 23,
    width: 91,
    height: 5,
    fill: "#E2E5E5"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 141,
    width: 130,
    height: 4,
    fill: "#E2E5E5"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 148,
    width: 30,
    height: 4,
    fill: "#E2E5E5"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 148,
    width: 74,
    height: 4,
    fill: "#E2E5E5"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 60,
    width: 33,
    height: 44,
    fill: "#E2E5E5"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 60,
    width: 33,
    height: 44,
    fill: "#E2E5E5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoDont);
export default __webpack_public_path__ + "static/media/do-dont.59525f34a179c36aaa8a0e68d95cc33c.svg";
export { ForwardRef as ReactComponent };